(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('forced-password-change', {
            parent: 'app',
            url: '/forced-password-change',
            data: {
                pageTitle: 'abcQualityMatchApp.forcedPasswordChange.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/forced-password-change/forced-password-change.html',
                    controller: 'ForcedPasswordChangeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forcedPasswordChange');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
